export default __webpack_public_path__ + "static/media/2-3.29e6a786.jpg";